import { Entity, PatientOptions } from "@/types";
export const DEFAULT_ROW_PER_PAGE = 10;
export const GENDER = {
  2: '女',
  1: '男',
  0: '女'
}

export const DOWNLOADKEYS = {
  '日期':'日期',
  'iid':'iid',
  '姓名':'姓名',
  '機器':'機器',
  '血糖':'血糖',
  'Meal':'MEAL',
  '體溫':'體溫',
  '收縮壓':'收縮壓',
  '舒張壓':'舒張壓',
  '脈膊':'脈膊',
  '右手握力':'右手握力',
  '左手握力':'左手握力',
  '走路速度':'走路速度',
  '走路時間':'走路時間',
  '五次坐站時間':'五次坐站時間',
  '身高':'身高',
  '體重':'體重',
  'BMI':'BMI',
  '量測期間血氧最高值':'量測期間血氧最高值',
  '量測期間血氧最低值':'量測期間血氧最低值',
  '量測期間最低脈膊':'量測期間最低脈膊',
  '量測期間最高脈膊':'量測期間最高脈膊'
}
export const CHARTMEASUREITEM = [
  {
    id: 10, name_en: "blood_pressure", name: "血壓", children: [
      {
        id: 11, name_en: "systolic", name: "收縮壓",
      },
      {
        id: 12, name_en: "diastolic", name: "舒張壓",
      },
      {
        id: 13, name_en: "pulse", name: "脈膊",
      },
    ]
  },
  {
    id: 20, name_en: "blood_glucose", name: "血糖", children: [
      {
        id: 21, name_en: "blood_glucose", name: "血糖",
      }
    ]
  },
  {
    id: 50, name_en: "spo2", name: "血氧", children: [
      {
        id: 51, name_en: "spO2_highest", name: "量測期間血氧最高值",
      },
      {
        id: 52, name_en: "spO2_lowest", name: "量測期間血氧最低值",
      },
      {
        id: 53, name_en: "pulse_highest", name: "量測期間最高脈膊",
      },
      {
        id: 54, name_en: "pulse_lowest", name: "量測期間最低脈膊",
      }
    ]
  },
]
export const MEASUREITEM = [
  {
    id: 10, name_en: "blood_pressure", name: "血壓", children: [
      {
        id: 11, name_en: "systolic", name: "收縮壓",
      },
      {
        id: 12, name_en: "diastolic", name: "舒張壓",
      },
      {
        id: 13, name_en: "pulse", name: "脈膊",
      },
      {
        id: 14, name_en: "scene", name: "情境",
      },
      {
        id: 15, name_en: "arr", name: "心律不整",
      },
      {
        id: 16, name_en: "afib", name: "心房顫動",
      },
      {
        id: 17, name_en: "pc", name: "早期收縮",
      },
      {
        id: 18, name_en: "ihb", name: "心跳不規則",
      }
    ]
  },
  {
    id: 20, name_en: "blood_glucose", name: "血糖", children: [
      {
        id: 21, name_en: "blood_glucose", name: "血糖",
      },
      {
        id: 22, name_en: "meal", name: "Meal",
      }
    ]
  },
  {
    id: 30, name_en: "metabolic", name: "新陳代謝", children: [
      {
        id: 31, name_en: "height", name: "身高",
      },
      {
        id: 32, name_en: "weight", name: "體重",
      },
      {
        id: 33, name_en: "bmi", name: "BMI",
      },
      {
        id: 34, name_en: "muscle_mass", name: "肌肉量",
      },
      {
        id: 35, name_en: "body_fat", name: "脂肪率",
      },
      {
        id: 36, name_en: "body_water", name: "水分含量",
      },
      {
        id: 37, name_en: "visceral_fat", name: "內臟脂肪率",
      },
      {
        id: 38, name_en: "bmr", name: "基礎代謝率",
      },
    ]
  },
  {
    id: 40, name_en: "body_temperature", name: "體溫", children: [
      {
        id: 41, name_en: "body_temperature", name: "體溫",
      }
    ]
  },
  {
    id: 50, name_en: "spo2", name: "血氧", children: [
      {
        id: 51, name_en: "spO2_highest", name: "量測期間血氧最高值",
      },
      {
        id: 52, name_en: "spO2_lowest", name: "量測期間血氧最低值",
      },
      {
        id: 53, name_en: "pulse_highest", name: "量測期間最高脈膊",
      },
      {
        id: 54, name_en: "pulse_lowest", name: "量測期間最低脈膊",
      },
      {
        id: 55, name_en: "act_highest", name: "量測期間最高",
      }
    ]
  },
  {
    id: 60, name_en: "frailty", name: "體適能", children: [
      {
        id: 61, name_en: "handness", name: "慣用手",
      },
      {
        id: 62, name_en: "left_grip", name: "左手握力",
      },
      {
        id: 63, name_en: "right_grip", name: "右手握力",
      },
      {
        id: 64, name_en: "walktime", name: "走路時間",
      },
      {
        id: 65, name_en: "walkspeed", name: "走路速度",
      },
      {
        id: 66, name_en: "ftsst", name: "五次坐站時間",
      },
      {
        id: 67, name_en: "sarcopenia", name: "肌少症",
      },
    ]
  },
  {
    id: 70, name_en: "blood", name: "血液", children: [
      {
        id: 71, name_en: "hb", name: "血紅素",
      },
      {
        id: 72, name_en: "alb", name: "白蛋白",
      },
      {
        id: 73, name_en: "cre", name: "腎功能",
      },
      {
        id: 74, name_en: "ast", name: "肝功能",
      },
      {
        id: 75, name_en: "tcho", name: "總膽固醇",
      },
      {
        id: 76, name_en: "hdl", name: "血高密度脂蛋白液",
      },
      {
        id: 77, name_en: "ldl", name: "低密度脂蛋白",
      },
      {
        id: 78, name_en: "ua", name: "尿酸",
      },
      {
        id: 79, name_en: "hba1c", name: "糖化血色素",
      },
      {
        id: 710, name_en: "fe", name: "鐵質",
      },
      {
        id: 711, name_en: "mg", name: "血鎂",
      }
    ]
  },
  {
    id: 80, name_en: "mental", name: "心理", children: [
      {
        id: 81, name_en: "spmsq", name: "SPMSQ",
      },
      {
        id: 82, name_en: "ad8", name: "AD-8",
      },
      {
        id: 83, name_en: "minicog", name: "Mini-Cog",
      },
      {
        id: 84, name_en: "bsrs", name: "BSRS",
      }
    ]
  },
  {
    id: 90, name_en: "bone", name: "骨質", children: [
      {
        id: 91, name_en: "osteoporosis", name: "Osteoporosis",
      },
      {
        id: 92, name_en: "fracture", name: "Fracture",
      }
    ]
  },
];

export const DISPLAYMEASUREITEM = [
  {
    id: 10, name_en: "blood_pressure", name: "血壓", children: [
      {
        id: 11, category:"blood_pressure", name_en: "systolic", name: "收縮壓",
      },
      {
        id: 12, category:"blood_pressure", name_en: "diastolic", name: "舒張壓",
      },
      {
        id: 13, category:"blood_pressure", name_en: "pulse", name: "脈膊",
      },
      {
        id: 14, category:"blood_pressure", name_en: "afib", name: "心房顫動",
      },
    ]
  },
  {
    id: 30, name_en: "metabolic", name: "新陳代謝", children: [
      {
        id: 31, category: "metabolic", name_en: "height", name: "身高",
      },
      {
        id: 32, category: "metabolic", name_en: "weight", name: "體重",
      },
      {
        id: 33, category: "metabolic", name_en: "bmi", name: "BMI",
      },
      {
        id: 34, category: "metabolic", name_en: "muscle_mass", name: "肌肉量",
      },
      {
        id: 35, category: "metabolic", name_en: "body_fat", name: "脂肪率",
      },
      {
        id: 36, category: "metabolic", name_en: "body_water", name: "水分含量",
      },
      {
        id: 37, category: "metabolic", name_en: "visceral_fat", name: "內臟脂肪率",
      },
      {
        id: 38, category: "metabolic", name_en: "bmr", name: "基礎代謝率",
      },
      {
        id: 21, category: "blood_glucose", name_en: "blood_glucose", name: "血糖",
      },
      {
        id: 22, category: "blood_glucose", name_en: "meal", name: "Meal",
      }
    ]
  },
  {
    id: 50, name_en: "spo2", name: "血氧體溫", children: [
      {
        id: 51, category: "spo2", name_en: "spO2_highest", name: "量測期間血氧最高值",
      },
      {
        id: 52, category: "spo2", name_en: "spO2_lowest", name: "量測期間血氧最低值",
      },
      {
        id: 53, category: "spo2", name_en: "pulse_highest", name: "量測期間最高脈膊",
      },
      {
        id: 54, category: "spo2", name_en: "pulse_lowest", name: "量測期間最低脈膊",
      },
      {
        id: 41, category: "body_temperature", name_en: "body_temperature", name: "體溫",
      }
    ]
  },
  {
    id: 60, name_en: "frailty", name: "體適能", children: [
      {
        id: 61, category: "frailty", name_en: "handness", name: "慣用手",
      },
      {
        id: 62, category: "frailty", name_en: "left_grip", name: "左手握力",
      },
      {
        id: 63, category: "frailty", name_en: "right_grip", name: "右手握力",
      },
      {
        id: 64, category: "frailty", name_en: "walktime", name: "走路時間",
      },
      {
        id: 65, category: "frailty", name_en: "walkspeed", name: "走路速度",
      },
      {
        id: 66, category: "frailty", name_en: "ftsst", name: "五次坐站時間",
      },
      {
        id: 67, category: "frailty", name_en: "sarcopenia", name: "肌少症",
      },
    ]
  },
  {
    id: 70, name_en: "blood", name: "血液", children: [
      {
        id: 71, category: "blood", name_en: "hb", name: "血紅素",
      },
      {
        id: 72, category: "blood", name_en: "alb", name: "白蛋白",
      },
      {
        id: 73, category: "blood", name_en: "cre", name: "腎功能",
      },
      {
        id: 74, category: "blood", name_en: "ast", name: "肝功能",
      },
      {
        id: 75, category: "blood", name_en: "tcho", name: "總膽固醇",
      },
      {
        id: 76, category: "blood", name_en: "hdl", name: "血高密度脂蛋白液",
      },
      {
        id: 77, category: "blood", name_en: "ldl", name: "低密度脂蛋白",
      },
      {
        id: 78, category: "blood", name_en: "ua", name: "尿酸",
      },
      {
        id: 79, category: "blood", name_en: "hba1c", name: "糖化血色素",
      },
      {
        id: 710, category: "blood", name_en: "fe", name: "鐵質",
      },
      {
        id: 711, category: "blood", name_en: "mg", name: "血鎂",
      },
      {
        id: 712, category: "blood", name_en: "prompe", name: "龐貝氏症",
      }
    ]
  },
  //{
  //  id: 80, name_en: "mental", name: "心智功能", children: [
  //    {
  //      id: 81, category: "mental", name_en: "spmsq", name: "SPMSQ",
  //    },
  //    {
  //      id: 82, category: "mental", name_en: "ad8", name: "AD-8",
  //    },
  //    {
  //      id: 83, category: "mental", name_en: "minicog", name: "Mini-Cog",
  //    },
  //    {
  //      id: 84, category: "mental", name_en: "bsrs", name: "BSRS",
  //    }
  //  ]
  //},
  //{
  //  id: 90, name_en: "bone", name: "骨質和牙齒", children: [
  //    {
  //      id: 91, category: "bone", name_en: "osteoporosis", name: "骨鬆指數",
  //    },
  //    {
  //      id: 92, category: "bone", name_en: "fracture", name: "骨折指數",
  //    },
  //    {
  //      id: 93, category:"bone", name_en: "caries", name: "蛀牙數",
  //    },
  //    {
  //      id: 94, category:"bone", name_en: "stone", name: "牙結石數",
  //    },
  //    {
  //      id: 95, category:"bone", name_en: "LossT", name: "缺牙數",
  //    },
  //    {
  //      id: 96, category:"bone", name_en: "intactT", name: "完整牙數",
  //    },
  //    {
  //      id: 97, category:"bone", name_en: "biting", name: "咬合力",
  //    },
  //  ]
  //},
  {
    id: 100, name_en: "lifestyle", name:"生活型態", children:[
      {
        id:101, category: "lifestyle", name_en: "step", name: "走路步數"
      },
      {
        id:102, category: "lifestyle", name_en: "Toss", name: "翻身次數"
      },
      {
        id:103, category: "lifestyle", name_en: "ComfortCount", name: "舒眠時間"
      },
      {
        id:104, category: "lifestyle", name_en: "LightCount", name: "淺眠時間"
      },
      {
        id:105, category: "lifestyle", name_en: "AwakeCount", name: "清醒時間"
      },
      {
        id:106, category: "lifestyle", name_en: "RemCount", name: "快速動眼時間"
      },
      {
        id:107, category: "lifestyle", name_en: "sleep_start_time", name: "睡眠起始時間"
      },
      {
        id:108, category: "lifestyle", name_en: "sleep_end_time", name: "睡眠結束時間"
      },
    ] 
  },
  //{
  //  id: 110, name_en: "multi_medication", name:"用藥", children:[
  //    {
  //      id:111, category: "multi_medication", name_en: "pim", name: "PIM種類"
  //    },
  //    {
  //      id:112, category: "multi_medication", name_en: "ddi", name: "藥物與藥物交互作用"
  //    },
  //    {
  //      id:113, category: "multi_medication", name_en: "types_of_medications", name: "症狀治療藥物種類"
  //   },
  //    {
  //      id:114, category: "multi_medication", name_en: "anti_acb", name: "Anti-ACB 分數"
  //    },
  //    {
  //      id:115, category: "multi_medication", name_en: "high_fall_risk_medication", name: "高治跌分數"
  //    },
  //  ] 
  //}
];

export const enum MEASUREMENT_STATUS {
  GOOD = 0,
  WARNING = 1,
  BAD = 2,
  UNKNOW = 3
}

export const MEASUREMENT_COLORS = {
  0: "#4FB99F",
  1: "#F0C419",
  2: "#C44F4B",
  3: "#000000"
}

export function getDefaultPagination(): Pagination {
  return {
    page: 1,
    totalItems: 0,
    rowsPerPage: DEFAULT_ROW_PER_PAGE,
    pages: 0
  };
}

export function getDefaultPatientOptions(): PatientOptions {
  return {
    page: 1,
    q: "",
    order: "asc",
    sort: "",
    range: undefined,
    place: ""
  };
}

export function getPagination(items: Entity[], pages: number, page: number, rowsPerPage: number = DEFAULT_ROW_PER_PAGE) {
  const totalItems = items ? items.length : 0;
  // const pages = Math.ceil(totalItems / DEFAULT_ROW_PER_PAGE);
  return { totalItems, pages, page, rowsPerPage };
}

export const DEVICEMEASUREMENTTYPE = {
  'bp':{
    name:'血壓', children:{
      'ppg_up': {
        name:'收縮壓', unit:'mmHg'
      },
      'ppg_low':{
        name:'舒張壓', unit:'mmHg'
      },
      'heart_beat':{
        name:'心跳', unit:'bpm'
      },
    }
  },
  'spo2':{
    name:'血氧', children:{
      'spo2':{
        name:'血氧',unit:'%'
      }
    }
  },
  'step':{
    name:'走路步數', children:{
      'step':{
        name:'走路步數', unit:'step'
      }
    }
  },
  'sleep':{
    name:'睡眠', children:{
      'Toss':{
        name:'翻身次數', unit:'times'
      },
      'ComfortCount':{
        name:'舒眠時間', unit:'minute'
      },
      'LightCount':{
        name:'淺眠時間', unit:'minute'
      },
      'AwakeCount':{
        name:'清醒時間', unit:'minute'
      },
      'RemCount':{
        name:'快速動眼時間', unit:'minute'
      }
    }
  }
};

export const COMMUNITYLIST = [
  "BG-1",
  "CT-1",
  "DL-5",
  "DN-2",
  "DN-3",
  "DP-1",
  "GK-1",
  "GK-3",
  "HW-3",
  "HW-5",
  "SH-1",
  "LB-1",
  "LN-4",
  "ML-2",
  "XL-1",
  "TK-3",
  "YZ-2",
];
